import * as React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { reduxForm } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { Loader } from '@components/loader';
import { AutoCompleteField, AutoComplete } from '@components/form';
import { createAttachment } from '@modules/records/_recordsActions';
import { withNotifications } from '@components/hoc/withNotifications';
import { required } from '@utils/validators';

const enhance = compose<any, any>(
  withNotifications({ createAttachment }),
  withState('loader', 'setLoader', false),
  reduxForm({
    form: 'module-events-record-document-create-add-attachment-photo'
  }),
  withHandlers({
    onSubmit: ({
      createAttachmentNotify,
      setLoader,
      documentId,
      closeItem,
      setAttachments,
      attachments
    }) => async formData => {
      setLoader(true);
      const response = await createAttachmentNotify(
        { file: formData.attachment, document: { id: documentId }, attachmentType: 'PHOTO' },
        documentId
      );
      if (response) {
        setAttachments([response, ...attachments]);
      }
      setLoader(false);
      closeItem();
    }
  })
);

const View: React.SFC<any> = ({ handleSubmit, onSubmit, closeItem, loader, photos }) => {
  return (
    <div>
      {loader && <Loader />}
      <form className="layout" onSubmit={handleSubmit(onSubmit)}>
        <Grid fluid={true}>
          <h4>Přidání fotodokumentace</h4>
          <Row>
            <Col md={6}>
              <AutoCompleteField
                component={AutoComplete}
                name="attachment"
                label="Fotodokumentace *"
                items={(photos || []).filter(({ contentType }) => /^image\//.test(contentType))}
                labelFunction={({ name }) => name}
                valueFunction={value => value}
                fullWidth={true}
                validate={required}
              />
            </Col>
          </Row>
        </Grid>

        <Divider />

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </form>
    </div>
  );
};

export const EventsFormRecordServicesFormPhotosForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormRecordServicesFormPhotosForm.tsx